// Shared Constants: Kullanıcı modülü değer kümeleri
// Bu dosya `sync-shared.js` ile frontend/src/shared/ ve backend/src/shared/
// dizinlerine kopyalanır. ⚠️ Kopyaları düzenleme, burayı düzenle.
//
// İkisi de DB ENUM'u değil: kolonlar serbest metin ve değerleri yalnız uygulama
// yazıyor. Arka yüz kaydı yazar, ön yüz etiketini basar; küme bu yüzden tek yerde.
// Etiket haritaları `Record<X, string>` ile tiplenir, eksik etiket `tsc`'yi kırar.
// Değerler kayıtlarda durduğu için değiştirilmez, yalnız eklenir.

// ─── Kullanıcı değişiklik kaydının türü (kullanici_degisiklik_loglari.islem_tipi) ───
export const KULLANICI_ISLEM_TIPI = {
    OLUSTURMA: 'OLUSTURMA',
    GUNCELLEME: 'GUNCELLEME',
    AKTIF: 'AKTIF',
    PASIF: 'PASIF',
    SILME: 'SILME',
    UNLOCK: 'UNLOCK',
    // Her davet gönderim denemesi (oluşturma, yeniden gönderme, adres düzeltme).
    DAVET: 'DAVET',
    DAVET_IPTAL: 'DAVET_IPTAL',
    // Davet bağlantısıyla şifre belirlendi; yapan kullanıcının kendisi.
    SIFRE_BELIRLEME: 'SIFRE_BELIRLEME',
    // Sıfırlama bağlantısıyla şifre değişti; yapan kullanıcının kendisi.
    SIFRE_SIFIRLAMA: 'SIFRE_SIFIRLAMA'
} as const;

// ─── Başarısız girişin nedeni (kullanici_giris_gecmisi.hata_nedeni) ───
export const GIRIS_HATA_NEDENI = {
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    PASSIVE_USER: 'PASSIVE_USER',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    WRONG_PASSWORD: 'WRONG_PASSWORD',
    // Hesap açılmış, şifre davet bağlantısıyla henüz belirlenmemiş.
    DAVET_BEKLIYOR: 'DAVET_BEKLIYOR'
} as const;

export const ALL_KULLANICI_ISLEM_TIPI = Object.values(KULLANICI_ISLEM_TIPI);
export const ALL_GIRIS_HATA_NEDENI = Object.values(GIRIS_HATA_NEDENI);

export type KullaniciIslemTipi = typeof ALL_KULLANICI_ISLEM_TIPI[number];
export type GirisHataNedeni = typeof ALL_GIRIS_HATA_NEDENI[number];
